import React, { useEffect, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { defaultSchema } from 'hast-util-sanitize';
import './index.css';

const schema = {
  ...defaultSchema,
  tagNames: [
    'a', 'b', 'i', 's', 'p', 'em', 'img', 'span', 'strong',
  ],
  attributes: {
    ...defaultSchema.attributes,
    a: ['href'],
    img: ['src', 'alt'],
    span: ['ariaExpanded'],
  },
};

function showSpoiler(e) {
  const spoiler = e.currentTarget;
  spoiler.setAttribute('aria-expanded', true);
}

function tagsSpoiler(text) {
  if (typeof text !== 'string') return text;
  const spoiler = /\|\|(.*?)\|\|/gm;
  return text.replace(spoiler, '<span aria-expanded="false">$1</span>');
}

function Markdown({ children, ...props }) {
  const processed = useMemo(() => tagsSpoiler(children), [children]);

  useEffect(() => {
    const spoilers = document.querySelectorAll('span[aria-expanded="false"]');
    spoilers.forEach((spoiler) => {
      spoiler.addEventListener('click', showSpoiler);
    });
    return () => {
      spoilers.forEach(spoiler => spoiler.removeEventListener('click', showSpoiler));
    };
  }, [processed]);

  return (
    <ReactMarkdown
      remarkPlugins={[gfm]}
      rehypePlugins={[[rehypeRaw], [rehypeSanitize, schema]]}
      components={{
        a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />, 
      }}
      {...props}
    >
      {processed}
    </ReactMarkdown>
  );
}

export default Markdown;
